// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";

interface ISVGContrastIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGContrastIcon extends PureComponent<
  ISVGContrastIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 45}
        fill={fill || "currentColor"}
        style={style}
        width="45"
        height="45"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 45 45"
      >
        <g id="Layer_1">
          <g id="background" display="none">
            <rect
              display="inline"
              fill="#050606"
              stroke="#FFFFFF"
              strokeWidth="0.1"
              strokeMiterlimit="10"
              width="35"
              height="35"
            />
          </g>
          <g id="Layer_2_1_"></g>
          <g id="Layer_1_2_" display="none">
            <g id="Layer_3" display="inline"></g>
            <g id="Layer_1_1_" display="inline"></g>
            <g display="inline">
              <g>
                <g enableBackground="new    ">
                  <g>
                    <polygon
                      fill="#808080"
                      points="22.982,26.572 25.719,34.699 24.783,33.241 22.538,26.572 						"
                    />
                  </g>
                  <g>
                    <path
                      fill="#808080"
                      d="M22.982,26.572l2.733,8.127L22.982,26.572z"
                    />
                  </g>
                  <g>
                    <polygon
                      fill="#B9B9B9"
                      points="21.111,22.307 22.047,23.764 12.759,23.764 13.404,22.307 						"
                    />
                  </g>
                  <g>
                    <path fill="#B9B9B9" d="M13.404,22.307h7.708H13.404z" />
                  </g>
                  <g>
                    <path
                      fill="#858585"
                      d="M18.852,13.918c0.234,0.783,1.309,4.068,3.195,9.846l-0.936-1.457
							c-1.891-5.779-2.961-9.055-3.195-9.847c-0.06-0.193-0.121-0.403-0.183-0.628c-0.006-0.023-0.01-0.036-0.013-0.048
							c0.094-0.331,0.183-0.666,0.268-1.007h0.099C18.348,12.091,18.609,13.135,18.852,13.918z"
                    />
                  </g>
                  <g>
                    <polygon
                      fill="#B9B9B9"
                      points="19.293,6.529 20.229,7.987 16.323,7.987 15.387,6.529 						"
                    />
                  </g>
                  <g>
                    <polygon
                      fill="#818181"
                      points="15.387,6.529 16.323,7.987 4.227,34.699 3.291,33.241 						"
                    />
                  </g>
                  <g>
                    <path
                      fill="#D4D4D4"
                      d="M20.229,7.987l9.576,26.712h-4.086l-2.734-8.127H22.54H11.553l-3.51,8.127H4.227L16.323,7.987H20.229z
							 M12.759,23.764h9.288c-1.89-5.778-2.961-9.063-3.195-9.846c-0.242-0.783-0.504-1.827-0.765-3.141h-0.099
							c-0.085,0.341-0.174,0.676-0.268,1.007c-0.4,1.418-0.876,2.747-1.424,3.988l-2.892,6.535L12.759,23.764"
                    />
                  </g>
                  <g>
                    <path fill="#D4D4D4" d="M12.759,23.764h9.288H12.759z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Layer_3_1_" display="none">
            <g id="Layer_2" display="inline">
              <g>
                <path
                  fill="#FFFFFF"
                  d="M32.645,5.066c-2.633-1.967-5.074-3.755-9.537-3.965c-0.424,0.271-1.354,0.055-1.885,0.189
					c-1.123,0.283-2.201,0.598-3.207,1.038c-1.874,0.819-3.451,2.223-5,3.399C12.54,6.23,12.07,6.733,11.597,7.236
					c0.078,1.344,2.878,3.11,3.87,3.774c1.443,0.966,2.973,1.848,4.813,2.452c5.051,1.663,9.859-1.563,12.555-3.584
					c0.807-0.605,1.377-1.564,2.17-2.17C34.938,6.494,33.415,5.644,32.645,5.066z M19.618,2.895c0.729-0.593,2.13-0.282,2.927-0.754
					c1.879,0.021,3.023,0.463,4.434,0.661c0.285,0.539,0.737,0.988,0.942,1.604c1.146,3.423-1.358,5.81-3.772,6.417
					C19.662,11.949,16.667,5.607,19.618,2.895z M25.09,12.709c-0.609,0.167-2.971,0.165-3.583,0c-3.03-0.814-7.091-2.934-8.59-5.189
					c-0.103-0.086-0.008,0.007-0.093-0.095c0.869-0.583,1.507-1.546,2.36-2.17c0.784-0.576,1.833-0.94,2.545-1.604
					c0.064,0,0.126,0,0.19,0c-1.78,4.294,1.222,7.422,4.625,8.211c0.452,0.103,1.204-0.026,1.509-0.096
					c2.676-0.61,3.979-1.639,4.814-4.058c0.35-1.017,0.471-3.14-0.192-3.965c0-0.03,0-0.062,0-0.095
					c2.163,0.591,3.449,2.696,5.097,3.776C32.271,9.725,28.158,11.874,25.09,12.709z"
                />
                <path
                  fill="none"
                  d="M24.148,10.822c2.412-0.607,4.916-2.995,3.771-6.417c-0.205-0.616-0.657-1.065-0.94-1.604
					c-1.414-0.197-2.558-0.642-4.436-0.661c-0.797,0.473-2.197,0.161-2.928,0.754C16.667,5.607,19.662,11.949,24.148,10.822z
					 M20.848,5.443c0.271-0.952,0.965-1.219,1.604-1.794c0.217-0.019,0.263-0.019,0.376-0.094c3.552-0.11,3.801,4.164,1.035,4.907
					C22.223,8.905,20.368,7.097,20.848,5.443z"
                />
                <path
                  fill="#FFFFFF"
                  d="M23.866,8.463c2.762-0.744,2.513-5.018-1.039-4.908c-0.113,0.077-0.159,0.077-0.376,0.095
					c-0.639,0.574-1.332,0.842-1.604,1.793C20.368,7.097,22.223,8.905,23.866,8.463z"
                />
                <path
                  fill="none"
                  d="M28.675,3.745c0.664,0.826,0.543,2.947,0.191,3.964c-0.834,2.419-2.142,3.447-4.813,4.058
					c-0.306,0.069-1.057,0.199-1.509,0.095c-3.403-0.787-6.405-3.917-4.625-8.211c-0.063,0-0.126,0-0.191,0
					c-0.711,0.665-1.76,1.028-2.546,1.605c-0.851,0.623-1.489,1.585-2.359,2.17c0.085,0.103-0.009,0.008,0.094,0.095
					c1.499,2.255,5.56,4.374,8.589,5.188c0.613,0.167,2.975,0.169,3.584,0c3.066-0.833,7.182-2.984,8.684-5.283
					c-1.646-1.08-2.937-3.185-5.099-3.774C28.675,3.682,28.675,3.714,28.675,3.745z"
                />
              </g>
            </g>
          </g>
          <g id="Layer_5">
            <g>
              <path
                fill="#05ABD7"
                stroke="#FFFFFF"
                strokeMiterlimit="10"
                d="M25.463,35h-3.748l-2.943-7.631H8.303L5.533,35H2.025
				l9.632-25.078h3.575L25.463,35z M17.763,24.736c-2.053-5.428-3.21-8.511-3.472-9.25c-0.263-0.734-0.554-1.719-0.873-2.951h-0.085
				c-0.32,1.688-0.747,3.25-1.284,4.687l-2.807,7.511h8.521V24.736z"
              />
            </g>
          </g>
          <g id="Layer_5_1_">
            <g>
              <path
                fill="#05ABD7"
                stroke="#FFFFFF"
                strokeMiterlimit="10"
                d="M23.438,35h-3.748l-2.94-7.631H6.278L3.508,35H0L9.632,9.922
				h3.575L23.438,35z M15.74,24.736c-2.054-5.428-3.21-8.511-3.474-9.25c-0.262-0.734-0.553-1.719-0.873-2.951h-0.085
				c-0.32,1.688-0.747,3.25-1.284,4.687l-2.806,7.511h8.521V24.736z"
              />
            </g>
          </g>
          <g id="Layer_4_1_">
            <g id="Layer_2_4_">
              <g>
                <path
                  fill="#05ABD7"
                  stroke="#FFFFFF"
                  strokeMiterlimit="10"
                  d="M32.572,5.158c-2.713-2.245-5.227-4.283-9.82-4.523
					c-0.439,0.308-1.396,0.063-1.941,0.217c-1.157,0.322-2.269,0.681-3.304,1.183c-1.929,0.935-3.552,2.535-5.152,3.877
					c-0.485,0.574-0.973,1.147-1.457,1.722c0.079,1.534,2.964,3.548,3.984,4.304c1.487,1.103,3.063,2.108,4.957,2.799
					c5.198,1.895,10.151-1.784,12.927-4.089c0.826-0.69,1.418-1.784,2.234-2.476C34.934,6.786,33.365,5.816,32.572,5.158z
					 M19.159,2.681c0.75-0.677,2.19-0.321,3.015-0.86c1.932,0.023,3.111,0.528,4.563,0.754c0.297,0.613,0.76,1.126,0.973,1.83
					c1.184,3.903-1.398,6.626-3.885,7.32C19.203,13.01,16.119,5.776,19.159,2.681z M24.791,13.876c-0.627,0.192-3.059,0.189-3.689,0
					c-3.121-0.928-7.299-3.347-8.846-5.921c-0.105-0.096-0.006,0.01-0.093-0.107c0.894-0.665,1.551-1.764,2.43-2.476
					c0.806-0.656,1.888-1.072,2.621-1.831c0.065,0,0.128,0,0.193,0c-1.832,4.899,1.26,8.467,4.767,9.367
					c0.465,0.12,1.236-0.027,1.551-0.108c2.756-0.693,4.096-1.868,4.959-4.628c0.359-1.16,0.486-3.582-0.197-4.522
					c0-0.035,0-0.072,0-0.108c2.23,0.675,3.557,3.074,5.25,4.308C32.189,10.471,27.955,12.923,24.791,13.876z"
                />
                <path
                  fill="#05ABD7"
                  stroke="#FFFFFF"
                  strokeMiterlimit="10"
                  d="M23.82,11.724c2.488-0.693,5.064-3.417,3.889-7.32
					c-0.213-0.703-0.676-1.216-0.975-1.83c-1.453-0.226-2.631-0.732-4.563-0.755c-0.824,0.54-2.265,0.184-3.014,0.86
					C16.119,5.776,19.203,13.01,23.82,11.724z M20.424,5.589c0.279-1.086,0.994-1.39,1.65-2.047
					c0.227-0.021,0.273-0.021,0.391-0.107c3.656-0.125,3.912,4.75,1.066,5.599C21.842,9.538,19.931,7.474,20.424,5.589z"
                />
                <path
                  fill="#05ABD7"
                  stroke="#FFFFFF"
                  strokeMiterlimit="10"
                  d="M23.533,9.034c2.842-0.848,2.588-5.724-1.068-5.601
					c-0.115,0.087-0.164,0.087-0.389,0.108c-0.658,0.657-1.373,0.961-1.652,2.047C19.931,7.474,21.842,9.538,23.533,9.034z"
                />
                <path
                  fill="#05ABD7"
                  stroke="#FFFFFF"
                  strokeMiterlimit="10"
                  d="M28.484,3.651c0.686,0.939,0.559,3.361,0.197,4.523
					c-0.863,2.758-2.207,3.931-4.959,4.629c-0.313,0.079-1.086,0.226-1.551,0.105c-3.506-0.896-6.599-4.466-4.768-9.367
					c-0.063,0-0.127,0-0.194,0c-0.73,0.758-1.812,1.174-2.621,1.831c-0.876,0.711-1.534,1.81-2.431,2.476
					c0.09,0.118-0.007,0.009,0.098,0.108c1.545,2.571,5.725,4.989,8.844,5.918c0.631,0.193,3.064,0.194,3.691,0
					c3.16-0.948,7.396-3.405,8.941-6.026c-1.693-1.232-3.023-3.634-5.25-4.305C28.484,3.578,28.484,3.615,28.484,3.651z"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Layer_2_3_"></g>
      </svg>
    );
  }
}
